import { render } from "./IniFileDeviceSetting.vue?vue&type=template&id=5da4389c&scoped=true"
import script from "./IniFileDeviceSetting.vue?vue&type=script&lang=js"
export * from "./IniFileDeviceSetting.vue?vue&type=script&lang=js"

import "./IniFileDeviceSetting.vue?vue&type=style&index=0&id=5da4389c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da4389c"]])

export default __exports__